var _path, _path2, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2837 6.23876C32.6477 5.56129 33.1849 4.99583 33.8389 4.60187C34.4929 4.20791 35.2394 4 36 4C36.7606 4 37.5071 4.20791 38.1611 4.60187C38.8151 4.99583 39.3523 5.56129 39.7163 6.23876L55.098 33.7916L70.3877 61.1583C70.7796 61.8388 70.9905 62.6109 70.9997 63.399C71.0089 64.187 70.8161 64.9639 70.4403 65.6537C70.0645 66.3434 69.5185 66.9223 68.8558 67.3336C68.1931 67.7449 67.4364 67.9746 66.6599 68H5.34009C4.5636 67.9746 3.80689 67.7449 3.14419 67.3336C2.4815 66.9223 1.93551 66.3434 1.55969 65.6537C1.18386 64.9639 0.991106 64.187 1.00032 63.399C1.00952 62.6109 1.22043 61.8388 1.61226 61.1583L16.902 33.7916L32.2837 6.23876Z",
    stroke: "url(#paint0_linear_1289_16489)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.398 49.4178C32.4336 43.422 31.9665 37.3507 32.0019 31.2713V23H40.9944V31.2713C41.058 37.3537 40.5759 43.429 39.5543 49.4178H33.398ZM32.4306 56.7383C32.4306 55.6081 32.8615 54.524 33.6284 53.7248C34.3953 52.9256 35.4356 52.4766 36.5202 52.4766C37.6048 52.4766 38.645 52.9256 39.4119 53.7248C40.1789 54.524 40.6097 55.6081 40.6097 56.7383C40.6097 57.8686 40.1789 58.9526 39.4119 59.7518C38.645 60.551 37.6048 61 36.5202 61C35.4356 61 34.3953 60.551 33.6284 59.7518C32.8615 58.9526 32.4306 57.8686 32.4306 56.7383V56.7383Z",
    stroke: "url(#paint1_linear_1289_16489)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1289_16489",
    x1: 11.0614,
    y1: 6.74948,
    x2: 47.8701,
    y2: 52.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1289_16489",
    x1: 33.2936,
    y1: 24.6325,
    x2: 44.5522,
    y2: 27.6698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e6f85b4e.svg";
export { ForwardRef as ReactComponent };